import React from 'react';
import {
  Edit as RaEdit,
  Toolbar,
  SaveButton,
  SimpleForm,
  TextInput,
  TextField,
} from 'react-admin';
import { withPermissions } from '../../components/hoc/WithPermissions';
import { USER_TYPE } from '../../constants/statuses';

const DomainToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const Edit = (props) => {
  const redirect = (basePath) => `${basePath}`;

  return (
    <RaEdit {...props}>
      <SimpleForm redirect={redirect} toolbar={<DomainToolbar />}>
        <TextField source="id" />
        <TextInput source="name" />
      </SimpleForm>
    </RaEdit>
  );
};

export default withPermissions(
  Edit,
  [USER_TYPE.DEVELOPER, USER_TYPE.BUYER],
);
